<template>
  <div class="sign_in">
    <img :src="mottoURL" class="sign_in-motto" draggable="false" />
    <h4 class="sign_in-spirit">公为天下 诚实守信 勇猛精进 毅然果决</h4>
    <div class="sign_in-button">
      <z-button type="primary" size="medium" @click="signIn">账号登录</z-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import {
    getAccessToken,
    getUserIP,
    getUserCity,
    getUserWeather
  } from "@/api/sign";
  export default {
    name: "SignIn",
    data() {
      return {
        //
        mottoURL: require("@/assets/Common/motto.png")
      };
    },
    computed: {
      // getters
      ...mapGetters(["userInfo"]),
      // 是否登录
      hasUserInfo() {
        return Object.keys(this.userInfo).length > 1;
      }
    },
    created() {
      this.handleGetCodeAndState();
    },
    methods: {
      // 获取用户登录状态
      handleGetCodeAndState() {
        // if (this.hasUserInfo) {
        //   this.$router.push({ name: "Welcome" });
        //   return;
        // }
        // const url = window.location.href;

        // let ticket;
        // let state;

        // let ticketIndex = url.indexOf("ticket=");
        // let routerIndex = url.indexOf("#/") !== -1 ? url.indexOf("#/") : url.length;

        // if (ticketIndex !== -1) {
        //   ticket = url.substring(ticketIndex + 7, routerIndex);
        //   console.log(ticket);

        //   this.$store.commit("SET_TOKEN",ticket);
        //   this.$store.dispatch("getInfo");
        // this.$router.push({ name: "Welcome" });


        // state = url.substring(stateIndex + 6, stateIndex + 12);
        // getAccessToken(code).then(res => {
        //   this.$store.commit("SET_TOKEN", res.data.access_token);
        //   this.$store.dispatch("getInfo");
        //   this.$router.push({ name: "Welcome" });
        // });

        // }
      },
      // 点击登录
      signIn() {
        const casUrl = `${process.env.VUE_APP_CAS_URL}login?service=${process.env.VUE_APP_URL}`;
        window.location.href = casUrl;
      }
    }
  };
</script>

<style lang="scss">
  @import "@/styles/variables.scss";
  .sign_in {
    padding-top: 18vh;
    &-motto {
      display: block;
      margin-top: 180px;
      width: 60vw;
      margin: 0 auto 8vh;
    }
    &-spirit {
      line-height: 18px;
      font-size: 18px;
      color: #fff;
      text-align: center;
      font-weight: lighter;
      letter-spacing: 4px;
      margin-bottom: 100px;
    }
    &-button {
      width: 30vw;
      min-width: 500px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .z-button {
        padding: 0 40px;
      }
    }
  }
</style>
